module.exports = __webpack_public_path__ + "static/fipcwhiteelephant2-96bcbeac2327ccac9060445232dceeae.jpeg";